import {Response, Model} from '@/_metronic/helpers'
export type Brand = Model & {
  name: string
  slug: string
  icon: string
  color: string
}

export type BrandsQueryResponse = Response<Array<Brand>>

export const initialBrand: Brand = {
  name: '',
  slug: '',
  icon: '',
  color: ''
}
